import axios from "axios";
import { useInfiniteQuery } from "@tanstack/react-query";

import { Keys } from "clients/apis/_keys";
import { Routes } from "clients/apis/_routes";

const sellers = async (data: SellersReqT) => {
  const { pageParam, name, mobile } = data;

  const qs = `?page=${pageParam ?? 1}&name=${name ?? ""}&mobile=${
    mobile ?? ""
  }`;

  return axios.get(Routes.SELLERS + qs);
};

export const useSellers = (params: SellersReqT) => {
  const { name, mobile } = params;

  return useInfiniteQuery({
    queryKey: [Keys.SELLERS_QRY, name, mobile],
    queryFn: ({ pageParam = 1 }) => sellers({ pageParam, ...params }),
    getNextPageParam: (lastPage) => {
      return lastPage.data.links.next
        ? lastPage.data.meta.current_page + 1
        : null;
    },
    getPreviousPageParam: (firstPage) => firstPage.data.links.prev,
    cacheTime: 0,
  });
};
